/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/no-document-1218402': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21.71 20.29l-18-18a1 1 0 00-1.42 1.42L4 5.41V19a3 3 0 003 3h10a3 3 0 002.39-1.2l.9.91a1 1 0 001.42 0 1 1 0 000-1.42zM17 20H7a1 1 0 01-1-1V7.41l11.93 11.93A1 1 0 0117 20zM8.66 4H12v3a3 3 0 003 3h3v3.34a1 1 0 102 0V9v-.06a1.31 1.31 0 00-.06-.27v-.09a1.07 1.07 0 00-.19-.28l-6-6a1.07 1.07 0 00-.28-.19h-.09L13.06 2h-4.4a1 1 0 000 2zM14 5.41L16.59 8H15a1 1 0 01-1-1z"/>'
  }
})
